export const PlanOfCare = {
    planOfCare: {
        version: ['e1'],
        timepoint: ['*'],
    },
};
